import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

export interface SseConfig {
  lockName: string;
  cursorStorageKey: string;
  url: (lastId: string | null) => string;
}

export const SSE_CONFIG = new InjectionToken<SseConfig>('SSE_CONFIG');

export function provideSse(config: SseConfig): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: SSE_CONFIG, useValue: config }]);
}
